class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Explicitly toggle desktop mega-menus. This avoids relying on browser
    // differences in native <summary> click/focus behaviour (notably Safari).
    const summary = this.mainDetailsToggle.querySelector(':scope > summary');
    if (summary) {
      summary.addEventListener('click', (event) => {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        event.preventDefault();

        const shouldOpen = !this.mainDetailsToggle.open;
        if (shouldOpen) {
          this.closest('.header__inline-menu')?.querySelectorAll('header-menu').forEach((other) => {
            if (other !== this && other.mainDetailsToggle?.open) other.close();
          });
        }
        this.mainDetailsToggle.open = shouldOpen;
        summary.setAttribute('aria-expanded', String(shouldOpen));
        if (shouldOpen) summary.focus({ preventScroll: true });
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
